import { QueryClient } from '@tanstack/react-query';

/**
 * The app's one query client — the cache every feature's server state is read through (TanStack
 * Query, lead decision 2026-09-24; `forge-et-fe/CLAUDE.md` "Server state goes through the query
 * layer"). `main.tsx` provides it at the root; nothing else imports this module.
 *
 * Two defaults differ from TanStack's, each for a reason:
 *
 *  - `retry: false` — a failed read reaches its error state at once, so every screen's error render
 *    is deterministic, and a refused read is not repeated: a retried `403` would trigger the session
 *    re-read of `GET /api/v1/me` once per attempt.
 *  - `refetchOnWindowFocus: false` — the one re-read on window focus is `SessionProvider`'s, of the
 *    session (`forge-et-fe/CLAUDE.md`: "never add a second re-read"). A feature that needs fresher
 *    data asks for it with its own `refetch`.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});
